<div id="resource-poppins" class="font-poppins" >
  <div>
      <nz-spin [nzTip]="url ? 'Please wait...' : Uploadprogress >= 100 ? 'Submitting, please wait...' : Uploadprogress === 0 ? '' :'Upload in progress' + ' ' + Uploadprogress + '%'" [nzSpinning]="isLoading">
      <!-- <div nz-row nzGutter="16" class="">
        <div nz-col class="gutter-row" nzSpan="12"></div>
      </div> -->
      <div nz-row nzGutter="16">
        <div
          nz-col
          class="gutter-row"
          nzSpan="24"
          style="text-align: right; width: 100%; height: 20px"
        >
          <a
            title="Cancel"
            (click)="this.checkFormState()"
            style="float: right; margin-bottom: 20px"
            ><i nz-icon nzType="close" theme="outline"></i
          ></a>
        </div>
      </div>
      <!-- <div  class="form-container" [class.disabled]="isLoading"> -->
        <form nz-form nzLayout="vertical" [formGroup]="resourceForm" >

          <nz-form-item>
            <nz-form-label for="resource_title" nzRequired >Resource Title</nz-form-label>
            <nz-form-control
              _ngcontent-jfp-c14=""
              class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
            >
              <div class="ant-form-item-control">
                <span class="ant-form-item-children">
                  <input
                    _ngcontent-jfp-c14=""
                    nz-input=""
                    formControlName="resource_name"
                    placeholder="Resource Name"
                    nzSize="medium"
                    class="ant-input ng-untouched ng-pristine ng-invalid" /><span
                    class="ant-form-item-children-icon"
                  >
                  <span class="text-danger" *ngIf="resourceForm.get('resource_name')?.errors?.['required'] && resourceForm.get('resource_name')?.touched">Resource name is required.</span>
                  </span
                ></span>
              </div>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label for="Category" nzRequired>Category</nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="category_id"
                name="Category"
                nzPlaceHolder="Please select"
                nzSize="small"
                [ngClass]="
                  selectInvalid(this.resourceForm.controls['category_id'].invalid)
                "
              >
                <nz-option
                  *ngFor="let cat of resource_category"
                  [nzLabel]="cat.name"
                  [nzValue]="cat.resource_category_id"
                ></nz-option>
              </nz-select>
              <span class="text-danger" *ngIf="resourceForm.get('category_id')?.errors?.['required'] && resourceForm.get('category_id')?.touched">Category is required.</span>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item *ngIf="file">
            <nz-form-label nzFor="selectFile" nzRequired>Resource File<span class="infoTextSpan"> (Only PDF, Image & Video files are allowed.)</span></nz-form-label>
            <nz-form-control>
              <nz-upload
                [nzBeforeUpload]="beforeUpload"
                [nzShowUploadList]="true"
                [nzPreviewFile]="previewFile"
              >
                <button
                  nz-button
                  [ngClass]="{
                    'invalid-border':
                      resourceForm.get('File').invalid && submitted
                  }"
                >
                  <span nz-icon nzType="upload"></span>
                  Select file
                </button>
              </nz-upload>
              <span *ngIf="updateMode && fileList && !userSelectedNewFile">{{
                fileList.name
              }}</span>

              <span *ngIf="updateMode && !fileList && uploadedFileUrl"><a href="{{uploadedFileUrl}}" target="_blank">{{uploadedFileName}}</a>
              </span>

              <span *ngIf="!updateMode && fileList">{{ fileList.name }}</span>
            </nz-form-control>
            
          </nz-form-item>

          <nz-form-item *ngIf="url">
            <nz-form-label for="resource_url" nzRequired >Resource URL</nz-form-label>
            <nz-form-control>
              <input type="text" nz-input formControlName="resource_url" placeholder="Enter Resource URL" id="resource_url" required >
              <span class="text-danger" *ngIf="resourceForm.get('resource_url')?.errors?.['pattern']  ">Enter a valid URL</span>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzFor="Tag" >Tags</nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="tag"
                nzMode="tags"
                nzPlaceHolder="Please select"
                nzSize="small"
                [ngClass]="
                  selectInvalid(this.resourceForm.controls['tag'].invalid)
                "
                style="width:100%"
              >
                >
                <nz-option
                  *ngFor="let option of tagFilterList"
                  [nzLabel]="option.text"
                  [nzValue]="option.value"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          
          <nz-form-item>
            <nz-form-label nzFor="position" nzRequired>Position</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="position" nzSize="small" nzMin="1" nzMax="1000000"  [ngClass]="
              selectInvalid(this.resourceForm.controls['position'].invalid)
            "
            style="width:100%">
            </nz-input-number>
           
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label for="Document Notes">Document Notes</nz-form-label>
            <nz-form-control>
              <textarea nz-input placeholder="" [nzAutosize]="{ minRows: 3, maxRows: 5 }" formControlName="document_notes"></textarea>
            </nz-form-control>
          </nz-form-item>
        </form>
        <!-- Loading overlay -->
        <!-- <div class="overlay" *ngIf="isLoading"></div> -->
     
        <!-- </div> -->

      <div nz-col nzSpan="24">
    
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
          "
        >
          <div nz-col nzSpan="12">
            <button
            *ngIf="!updateMode"
            (click)="resetResourceForm()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
              nz-wave="[object Object]"
            >
              <!----><span>Reset</span>
            </button>
            <button
            *ngIf="updateMode"
            (click)="resetUpdateForm()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
              nz-wave="[object Object]"
            >
              <!----><span>Reset</span>
            </button>
          </div>
    
          <div nz-col nzSpan="12" style="text-align: right">
            <div style="display: inline; margin-right: 20px;">
              <span>
                File Shareable
              </span>
                <span class="">
                  <nz-switch [(ngModel)]="isShareable" [nzControl]="true" (click)="clickSwitch(isShareable)"
                    [nzLoading]="isLoading" nzSize="small" [nzDisabled]="this.isLoading"></nz-switch>
                </span>
              
            </div>
            
            <button
            nz-button=""
            nztype="default"
            class="cancelbtn-outline"
            (click)="this.checkFormState()"
            [disabled]="isLoading"

          >
            <span>Cancel</span>
          </button>
            <button
              nz-button=""
              nztype="default"
              *ngIf="!updateMode"
              class="ant-btn ant-btn-primary m-l-10"
              style="padding-left: 25px; padding-right: 25px"
              [nzLoading]="isLoading"
            (click)="submitResource()"
            [disabled]="!this.resourceForm.valid"
            >
              <span>Save</span>
            </button>
    
            <button
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-primary m-l-10"
              style="padding-left: 25px; padding-right: 25px"
              [disabled]="!(this.resourceForm.dirty || isFileSelected)"
              *ngIf="updateMode"
              [nzLoading]="isLoading"
              (click)="updateFile()"
      
            >
              <span>Update</span>
            </button>
          </div>
        </div>
      </div>

      <!-- <div nz-row class="drawer-footer">
        <div nz-col nzSpan="12">
          <button
            *ngIf="!updateMode"
            (click)="resetResourceForm()"
            nz-button=""
            nztype="default"
            class="ant-btn ant-btn-default"
          >
            <span>Reset</span>
          </button>
          <button
            *ngIf="updateMode"
            (click)="resetUpdateForm()"
            nz-button=""
            nztype="default"
            class="ant-btn ant-btn-default"
          >
            <span>Reset</span>
          </button>
        </div>
        <div nz-col nzSpan="12" style="text-align: right">
          <button
            nz-button=""
            nztype="default"
            class="cancelbtn-outline"
            style="padding-left: 25px; padding-right: 25px; margin-right: 10px"
            (click)="this.checkFormState()" 
          >
            <span>Cancel</span>
          </button>
          <button
            nz-button=""
            nztype="default"
            [nzLoading]="isLoading"
            *ngIf="!updateMode"
            class="ant-btn ant-btn-primary"
            style="padding-left: 25px"
            [nzLoading]="isLoading"
            (click)="submitResource()"
            [disabled]="!this.resourceForm.valid"
          >
            <span>Save</span>
          </button>
          <button
            nz-button=""
            nztype="default"
            *ngIf="updateMode"
            class="ant-btn ant-btn-primary"
            style="padding-left: 25px; padding-right: 25px"
            [nzLoading]="isLoading"
            (click)="updateFile()"
          >
            <span>Update</span>
          </button>
        </div>
      </div> -->
    </nz-spin>
    </div>
</div>
